@if (loaded) {
<div class="dashboard-page">
  @if(layoutError){<p class="layout-warning" role="status">{{layoutError}}</p>}
  <div class="dashboard-heading"><div><span class="eyebrow">YOUR WORKSPACE</span><h1>Dashboard</h1><p>Your queues, tracking, and requests in one place.</p></div><span class="widget-count">{{dashboard.length}} widgets</span></div>
  <div class="dash-toolbar">
    <button mat-stroked-button (click)="toggleEdit()">
      <mat-icon>dashboard_customize</mat-icon>
      {{ editDashboard ? 'Done customizing' : 'Customize' }}
    </button>

    <button mat-stroked-button [matMenuTriggerFor]="layoutMenu">
      <mat-icon>list_alt</mat-icon>
      Layouts {{ selectedLayout?.DashboardID ? ('(Current: ' + selectedLayout.LayoutName) + ')' : ''}}
    </button>
    <mat-menu #layoutMenu>
      <button mat-menu-item (click)="useDailyLayout()"><mat-icon>view_quilt</mat-icon>Daily overview · starter layout</button>
      <div class="layout-section">Default layout</div>
      @for (layout of DefaultLayout; track layout.DashboardID) {
      <button (click)="onChangeLayout(layout)" mat-menu-item>{{ layout.LayoutName }}</button>
      }
      <div class="layout-section">Your layouts</div>
      @for (layout of CustomLayouts; track layout.DashboardID) {
      <button (click)="onChangeLayout(layout)" mat-menu-item>{{ layout.LayoutName }}</button>
      }
      <div class="layout-section">Shared layouts</div>
      @for (layout of SystemLayouts; track layout.DashboardID) {
      <button (click)="onChangeLayout(layout)" mat-menu-item>{{ layout.LayoutName }}</button>
      }
    </mat-menu>
    @if(selectedLayout.DashboardID){
    <rms-checkbox label="Default Layout"
                  [(ngModel)]="selectedLayout.DefaultConfig"
                  (ngModelChange)="UpdateLayout()"
                  [disabled]="selectedLayout.DefaultConfig">
    </rms-checkbox>
    }
    <div class="spacer"></div>

    @if (editDashboard) {
    <button mat-button [matMenuTriggerFor]="addMenu">
      <mat-icon>add</mat-icon>Add Widget
    </button>
    <mat-menu #addMenu="matMenu">
      @for (widget of widgets; track widget.key) {
      <button mat-menu-item (click)="addWidget(widget.key,'md')">
        <mat-icon>assignment_turned_in</mat-icon>
        {{ widget.title }}
      </button>
      }
    </mat-menu>

    @if (selectedLayout.DashboardID) {
    <button mat-button (click)="UpdateLayout()"><mat-icon>save</mat-icon>Update</button>
    }
    <button mat-button (click)="clearAll()"><mat-icon>delete_sweep</mat-icon>Clear widgets</button>
    <button mat-button (click)="SaveCustomLayout()">
      <mat-icon>save_as</mat-icon>Save As New
    </button>
    }
  </div>

  <app-rms-prompt #prompt></app-rms-prompt>

  @if(editDashboard){<div class="edit-hint"><mat-icon>drag_indicator</mat-icon>Drag widget headers to rearrange. Resize from a corner, then save your layout.</div>}
  @if(!dashboard.length){<div class="empty-dashboard"><mat-icon>dashboard_customize</mat-icon><h2>Build your dashboard</h2><p>Choose a saved layout above or customize your workspace to add widgets.</p>@if(!editDashboard){<button mat-flat-button class="btn-bg-blue" (click)="toggleEdit()">Customize dashboard</button>}</div>}
  <div class="grid-scroll" [hidden]="!dashboard.length">
    <gridster [options]="options"
              [ngStyle]="{ background: editDashboard ? 'rgba(120,194,255,0.1)' : 'transparent' }">
      @for (item of dashboard; track item?.id ?? $index) {
      <gridster-item [item]="item">
        <app-grid-item [componentType]="componentFor(item.type)"
                       [title]="titleFor(item.type)"
                       [editable]="editDashboard"
                       [onRemove]="getRemoveHandler(item.id)"
                       [data]="item.data">
        </app-grid-item>
      </gridster-item>
      }
    </gridster>
  </div>
</div>
}

@if(!loaded){<div class="dashboard-loading" role="status">Loading your dashboard…</div>}
